import { Divider } from 'antd';

import { capitalize } from 'lodash';
import React from 'react';
import { DATE_FORMATS } from '../../../../../common/constants';
import { formatDate } from '../../../../../common/utils';
import CommonTable from '../../../../../components/CommonTable';
import ModalComponent from '../../../../../components/ModalComponent';

const PaymentTokenHistoryModal = ({
  title,
  isModalOpen,
  setIsModalOpen,
  statusHistories,
}) => {
  const columns = [
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => capitalize(record?.status) || '-',
    },
    {
      title: 'CREATED AT',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.createdAt, DATE_FORMATS?.WITH_TIME) || '-',
    },
  ];

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      title={title}
      width={600}
    >
      <Divider />
      <div className="mt-24">
        <CommonTable
          columns={columns}
          data={statusHistories}
          scroll={{ y: 350 }}
          rowKey={(record) => record?.id}
        />
      </div>
    </ModalComponent>
  );
};

export default PaymentTokenHistoryModal;
